import React, { useState } from 'react';
import './App.css';

const getDayGreeting = () => {
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const today = new Date();
  return `Happy ${days[today.getDay()]}!`;
};

const MOTIVATIONAL_QUOTES = [
  'Stay productive, stay positive!',
  'Every task brings you closer to your goals.',
  'Small steps every day!',
  'You are capable of amazing things.',
  'Make today count!'
];

function Confetti({ show }) {
  // Simple confetti using emoji
  if (!show) return null;
  return (
    <div className="confetti">
      {Array.from({ length: 30 }).map((_, i) => (
        <span key={i} className={`confetti-piece confetti-${i % 5}`}>🎉</span>
      ))}
    </div>
  );
}

function App() {
  const [tasks, setTasks] = useState([]);
  const [input, setInput] = useState('');
  const [time, setTime] = useState('');
  const [importance, setImportance] = useState('Normal');
  const [notification, setNotification] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const quote = MOTIVATIONAL_QUOTES[new Date().getDay() % MOTIVATIONAL_QUOTES.length];
  const userInitials = 'VK'; // Example initials, can be dynamic

  const showNotification = (msg, type = 'info') => {
    setNotification({ msg, type });
    setTimeout(() => setNotification(null), 2000);
  };

  const addTask = (e) => {
    e.preventDefault();
    if (input.trim() === '') return;
    setTasks([
      ...tasks,
      {
        id: Math.random().toString(36).substr(2, 6).toUpperCase(),
        text: input,
        completed: false,
        time: time,
        importance: importance
      }
    ]);
    setInput('');
    setTime('');
    setImportance('Normal');
    showNotification('Task added!', 'success');
    setShowForm(false);
  };

  const toggleTask = (id) => {
    setTasks(tasks.map(task =>
      task.id === id ? { ...task, completed: !task.completed } : task
    ));
    const toggled = tasks.find(task => task.id === id);
    showNotification(
      toggled && !toggled.completed ? 'Task completed!' : 'Task marked as pending!',
      'info'
    );
  };

  const deleteTask = (id) => {
    setTasks(tasks.filter(task => task.id !== id));
    showNotification('Task deleted!', 'error');
  };

  // UI summary
  const total = tasks.length;
  const completed = tasks.filter(t => t.completed).length;
  const pending = total - completed;
  const percent = total === 0 ? 0 : Math.round((completed / total) * 100);
  const allDone = total > 0 && completed === total;

  return (
    <div className="App fullpage glass-fade-in">
      <div className="background-pattern" />
      <Confetti show={allDone} />
      {notification && (
        <div className={`notification-toast ${notification.type}`}>{notification.msg}</div>
      )}
      <header className="main-header">
        <div className="header-icon">📝</div>
        <div>
          <h1>Task Manager Pro</h1>
          <p className="subtitle">Organize, Prioritize, and Succeed</p>
        </div>
        <div className="user-avatar" title="Your Profile">{userInitials}</div>
      </header>
      <div className="greeting-bar">
        <span className="greeting">
          <span className="greeting-emoji" role="img" aria-label="sun">☀️</span> {getDayGreeting()}
        </span>
        <span className="quote fade-in-quote">{quote}</span>
      </div>
      <div className="center-content glass-card">
        <div className="summary-card elevated animated-border">
          <div className="summary-title">Dashboard</div>
          <div className="summary-stats">
            <span>Total: <b>{total}</b></span>
            <span>Completed: <b>{completed}</b></span>
            <span>Pending: <b>{pending}</b></span>
          </div>
          <div className="progress-bar-outer">
            <div className="progress-bar-inner" style={{ width: percent + '%' }} />
          </div>
          <div className="progress-label">{percent}% Complete</div>
        </div>
        <hr className="divider" />
        <div className="task-list-container">
          <ul className="task-list">
            {tasks.length === 0 && (
              <li className="no-tasks">No tasks yet. Add your first task!</li>
            )}
            {tasks.map(task => (
              <li key={task.id} className={`task-animate task-hover ${task.completed ? 'completed' : ''}`}> 
                <span className="task-main" onClick={() => toggleTask(task.id)}>
                  {task.text}
                  {task.time && <span className="task-time"> @ {task.time}</span>}
                  <span className={`task-importance ${task.importance.toLowerCase()}`}> [{task.importance}]</span>
                </span>
                <button onClick={() => deleteTask(task.id)} className="delete-btn">Delete</button>
              </li>
            ))}
          </ul>
        </div>
        <button className={`fab${tasks.length === 0 ? ' fab-pulse' : ''}`} onClick={() => setShowForm(true)} title="Quick Add Task">
          +
        </button>
        {showForm && (
          <div className="fab-form-modal" onClick={() => setShowForm(false)}>
            <form onSubmit={addTask} className="fab-form" onClick={e => e.stopPropagation()}>
              <input
                type="text"
                value={input}
                onChange={e => setInput(e.target.value)}
                placeholder="Quick task..."
                autoFocus
              />
              <div className="fab-form-row">
                <input
                  type="time"
                  value={time}
                  onChange={e => setTime(e.target.value)}
                  className="time-input"
                />
                <select
                  value={importance}
                  onChange={e => setImportance(e.target.value)}
                  className="importance-select"
                >
                  <option value="Low">Low</option>
                  <option value="Normal">Normal</option>
                  <option value="High">High</option>
                </select>
              </div>
              <button type="submit">Add</button>
            </form>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;
